import { Ref, ref } from '@vue/composition-api';
import { STATUS } from '@front-app/constants/state';
import { PartialUser, UserSalutation } from '@front-app/services/UserApi/UserModel';
import { InnerUserStore } from './model';

export const getPartialUserStore = (): InnerUserStore<PartialUser> => {
	const state: Record<string, Ref<PartialUser>> = {};
	const set = (user: PartialUser): void => {
		if (state[user.id]) {
			state[user.id].value = Object.assign(state[user.id].value, user);
		} else {
			state[user.id] = ref(user);
		}
	};
	const get = (id: string): Ref<PartialUser> => {
		const item = state[id];
		if (!item) {
			state[id] = ref(getPartialUserWithStatusAndId(id, STATUS.UNSTARTED));
		}
		return state[id];
	};
	const has = (id: string): boolean => Boolean(state[id]);
	return {
		set,
		get,
		has,
	};
};

function getPartialUserWithStatusAndId(id: string, status: STATUS): PartialUser {
	return {
		id,
		status,
		salutation: UserSalutation.NONE,
		displayName: '',
		firstName: '',
		middleName: '',
		lastName: '',
		authenticated: false,
		verified: false,
	};
}
